import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/fold2/BgImgNj.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="Toronto">
              <h2>A Web Design Company In NJ That Believes In Results</h2>
            </div>
            <p>
              A website isn’t there just to establish your brand presence in
              today's digital world as modern users expect more than just a
              flashy-looking website that’s aesthetically breathtaking and
              offers them real-time value. That’s exactly why we have embarked
              on a mission to offer web designing services in NJ with a focus on
              ensuring business growth.
            </p>
            <p>
              Our approach to any website project is first to understand your
              business model and strategy. Once we’ve understood what you
              exactly want, only then do we begin working on your website. Every
              function or feature that we put into your website is aimed towards
              aiding just one major goal i.e. to power maximum conversions,
              period!
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
